import { SyntheticEvent } from 'react';

/** GIF transparent de 1×1 pixel. */
const TRANSPARENT_PIXEL =
  'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

/**
 * Remplace une image cassée par un pixel transparent.
 *
 * Le navigateur affiche sinon son icône d'image brisée, et le texte alternatif
 * par-dessus. En substituant la source, l'élément ne rend plus rien mais garde
 * ses dimensions et sa couleur de fond : il ressemble alors au squelette de
 * chargement, ce qui est bien plus discret qu'une icône cassée.
 *
 * À poser sur les `<img>` dont la source vient de l'extérieur, avec la classe
 * `image-skeleton` pour la couleur de fond.
 */
export const onImageError = (event: SyntheticEvent<HTMLImageElement>) => {
  const image = event.currentTarget;

  // Sans ce garde, remplacer la source relancerait l'événement en boucle.
  if (image.src === TRANSPARENT_PIXEL) return;

  image.src = TRANSPARENT_PIXEL;
};
